import React, { useEffect, useState } from 'react';
import { ChevronLeft, ChevronRight } from 'lucide-react';
interface Testimonial {
  quote: string;
  author: string;
  role: string;
  company: string;
  image: string;
}
interface TestimonialCarouselProps {
  testimonials: Testimonial[];
}
export function TestimonialCarousel({
  testimonials
}: TestimonialCarouselProps) {
  const [currentIndex, setCurrentIndex] = useState(0);
  const [isAnimating, setIsAnimating] = useState(false);
  useEffect(() => {
    const interval = setInterval(() => {
      handleNext();
    }, 6000);
    return () => clearInterval(interval);
  }, [currentIndex]);
  const handleNext = () => {
    if (isAnimating) return;
    setIsAnimating(true);
    setCurrentIndex(prev => (prev + 1) % testimonials.length);
    setTimeout(() => setIsAnimating(false), 500);
  };
  const handlePrev = () => {
    if (isAnimating) return;
    setIsAnimating(true);
    setCurrentIndex(prev => (prev - 1 + testimonials.length) % testimonials.length);
    setTimeout(() => setIsAnimating(false), 500);
  };
  const current = testimonials[currentIndex];
  return <div className="relative" data-id="element-164">
      <div className={`transition-all duration-500 ${isAnimating ? 'opacity-0 translate-y-4' : 'opacity-100 translate-y-0'}`} data-id="element-165">
        <div className="flex items-start gap-6 mb-8" data-id="element-166">
          <img src={current.image} alt={current.author} className="w-20 h-20 rounded-full object-cover border-4 border-blue-100" data-id="element-167" />
          <div className="flex-1" data-id="element-168">
            <div className="text-6xl text-blue-600 mb-4 leading-none" data-id="element-169">"</div>
            <p className="text-xl text-slate-700 leading-relaxed mb-6 italic" data-id="element-170">
              {current.quote}
            </p>
            <div data-id="element-171">
              <div className="font-bold text-slate-900 text-lg" data-id="element-172">
                {current.author}
              </div>
              <div className="text-slate-600" data-id="element-173">{current.role}</div>
              <div className="text-sm text-blue-600 font-semibold" data-id="element-174">
                {current.company}
              </div>
            </div>
          </div>
        </div>
      </div>

      {/* Navigation */}
      <div className="flex items-center justify-between mt-8" data-id="element-175">
        <button onClick={handlePrev} className="p-3 bg-slate-100 hover:bg-slate-200 rounded-full transition-colors" aria-label="Previous testimonial" data-id="element-176">
          <ChevronLeft className="w-6 h-6 text-slate-700" data-id="element-177" />
        </button>

        <div className="flex gap-2" data-id="element-178">
          {testimonials.map((_, index) => <button key={index} onClick={() => {
          if (!isAnimating) {
            setIsAnimating(true);
            setCurrentIndex(index);
            setTimeout(() => setIsAnimating(false), 500);
          }
        }} className={`h-2 rounded-full transition-all duration-300 ${index === currentIndex ? 'w-8 bg-blue-600' : 'w-2 bg-slate-300'}`} aria-label={`Go to testimonial ${index + 1}`} data-id="element-179" />)}
        </div>

        <button onClick={handleNext} className="p-3 bg-slate-100 hover:bg-slate-200 rounded-full transition-colors" aria-label="Next testimonial" data-id="element-180">
          <ChevronRight className="w-6 h-6 text-slate-700" data-id="element-181" />
        </button>
      </div>
    </div>;
}